import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { EASE } from "@/components/Reveal";

export default function FaqAccordion({ items = [] }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="border-t border-burgundy/10">
      {items.map((item, i) => {
        const isOpen = open === i;
        return (
          <div key={i} className="border-b border-burgundy/10">
            <button
              type="button"
              data-testid={`faq-item-${i}`}
              aria-expanded={isOpen}
              aria-controls={`faq-panel-${i}`}
              onClick={() => setOpen(isOpen ? -1 : i)}
              className="w-full flex items-center justify-between gap-6 py-6 sm:py-7 text-left group"
            >
              <span className="font-serif text-lg sm:text-2xl text-ink group-hover:text-burgundy transition-colors duration-300">
                {item.q}
              </span>
              <span
                className={`shrink-0 w-9 h-9 rounded-full border flex items-center justify-center transition-all duration-500 ${
                  isOpen
                    ? "rotate-45 bg-burgundy text-ivory-light border-burgundy"
                    : "text-burgundy border-burgundy/25 group-hover:border-burgundy"
                }`}
                aria-hidden="true"
              >
                <Plus className="w-4 h-4" />
              </span>
            </button>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  id={`faq-panel-${i}`}
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.45, ease: EASE }}
                  className="overflow-hidden"
                >
                  <p className="pb-8 pr-4 sm:pr-16 text-[15px] text-ink-soft/90 font-light leading-relaxed max-w-2xl">
                    {item.a}
                  </p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
}
